(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["halo-countdown"] && !Shopify.designMode) return;
  try {
    (function(){
  function init(root){
    if(root.dataset.ready) return;
    root.dataset.ready = '1';

    var saleData = {};
    var saleEl = root.querySelector('[data-cd-sale]');
    try { saleData = JSON.parse(saleEl.textContent); } catch(e){}

    var mode = root.getAttribute('data-mode');
    var timerEl = root.querySelector('[data-cd-timer]');
    var elD = root.querySelector('[data-d]'), elH = root.querySelector('[data-h]');
    var elM = root.querySelector('[data-m]'), elS = root.querySelector('[data-s]');
    var target, iv;

    // ---- sale gate ----
    function form(){
      var scope = root.closest('.shopify-section, product-information, [id^="MainProduct"]') || document;
      return scope.querySelector('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
    }
    function currentId(){
      var f = form();
      if(f){
        var idInput = f.querySelector('input[name="id"], select[name="id"]');
        if(idInput && idInput.value) return idInput.value;
      }
      var m = window.location.search.match(/[?&]variant=(\d+)/);
      if(m) return m[1];
      return root.getAttribute('data-current');
    }
    function onSale(){
      var id = String(currentId() || '');
      return !!saleData[id];
    }

    var lastVisible = null;
    function applyGate(){
      var show = onSale();
      if(show === lastVisible) return;
      lastVisible = show;
      if(show){ root.removeAttribute('hidden'); startTimer(); }
      else { root.setAttribute('hidden',''); }
    }

    // ---- timer ----
    function setTarget(){
      if(mode === 'evergreen'){
        var hours = parseFloat(root.getAttribute('data-evergreen-hours')) || 24;
        var span = hours * 3600 * 1000;
        var key = 'halo_cd_' + Math.round(span);
        var saved = null;
        try { saved = localStorage.getItem(key); } catch(e){}
        if(saved){ target = parseInt(saved,10); }
        if(!target || isNaN(target) || target < Date.now()){
          target = Date.now() + span;
          try { localStorage.setItem(key, String(target)); } catch(e){}
        }
      } else {
        var d = root.getAttribute('data-deadline');
        target = d ? new Date(d.replace(/-/g,'/')).getTime() : NaN;
      }
    }
    function pad(n){ return (n<10?'0':'') + n; }
    function tick(){
      var diff = target - Date.now();
      if(diff <= 0){
        root.classList.add('halo-cd--expired');
        var txt = root.getAttribute('data-expired-text');
        if(txt && !root.querySelector('.halo-cd__expired')){
          var p = document.createElement('p');
          p.className = 'halo-cd__expired';
          p.textContent = txt;
          timerEl.parentNode.insertBefore(p, timerEl.nextSibling);
        }
        clearInterval(iv);
        return;
      }
      var s = Math.floor(diff/1000);
      var days = Math.floor(s/86400); s -= days*86400;
      var hrs = Math.floor(s/3600); s -= hrs*3600;
      var mins = Math.floor(s/60); s -= mins*60;
      elD.textContent = pad(days);
      elH.textContent = pad(hrs);
      elM.textContent = pad(mins);
      elS.textContent = pad(s);
    }
    function startTimer(){
      if(iv) return;                 // already running
      setTarget();
      if(isNaN(target)) return;      // no valid fixed date
      tick();
      iv = setInterval(tick, 1000);
    }

    // initial + watch for variant changes
    applyGate();

    document.addEventListener('variant:change', function(e){
      var variant = e.detail && (e.detail.variant || e.detail);
      if(variant && variant.id){ applyGate(); }
    });
    document.addEventListener('change', function(e){
      if(e.target && e.target.name === 'id'){ applyGate(); }
    });
    var f = form();
    if(f){
      var idInput = f.querySelector('input[name="id"], select[name="id"]');
      if(idInput){
        var mo = new MutationObserver(function(){ applyGate(); });
        mo.observe(idInput, { attributes:true, attributeFilter:['value'] });
      }
    }
    setInterval(applyGate, 400);
  }

  function initAll(){ document.querySelectorAll('[data-halo-cd]').forEach(init); }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', initAll); }
  else { initAll(); }
  document.addEventListener('shopify:section:load', initAll);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["halo-trust-strip"] && !Shopify.designMode) return;
  try {
    (function(){
    function init(root){
      if(root.dataset.haloInit) return;
      var wrap = root.querySelector('.halo-trust__wrap');
      if(!wrap) return;
      root.dataset.haloInit = '1';

      var originals = Array.prototype.slice.call(wrap.querySelectorAll('.halo-trust__item'));
      var N = originals.length;
      if(N < 2) return;

      originals.forEach(function(it){
        var c = it.cloneNode(true);
        c.classList.add('halo-trust__clone');
        c.setAttribute('aria-hidden', 'true');
        wrap.appendChild(c);
      });

      var DELAY = 3000;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var timer = null, jumping = false;

      function sliderActive(){ return getComputedStyle(wrap).display === 'flex'; }
      function step(){
        if(wrap.children.length < 2) return 0;
        return wrap.children[1].offsetLeft - wrap.children[0].offsetLeft;
      }

      function advance(){
        if(!sliderActive() || jumping) return;
        var s = step();
        if(s <= 0) return;
        var idx = Math.round(wrap.scrollLeft / s);
        var target = idx + 1;
        wrap.scrollTo({ left: target * s, behavior: 'smooth' });

        if(target >= N){
          jumping = true;
          var back = (target - N) * s;
          var reset = function(){
            wrap.scrollTo({ left: back, behavior: 'auto' });
            jumping = false;
          };
          if('onscrollend' in window){
            var h = function(){ wrap.removeEventListener('scrollend', h); reset(); };
            wrap.addEventListener('scrollend', h);
            setTimeout(function(){ if(jumping){ wrap.removeEventListener('scrollend', h); reset(); } }, 900);
          } else {
            setTimeout(reset, 550);
          }
        }
      }

      function start(){ if(reduce || timer) return; timer = setInterval(advance, DELAY); }
      function stop(){ if(timer){ clearInterval(timer); timer = null; } }
      function restart(){ stop(); start(); }

      wrap.addEventListener('pointerdown', stop);
      wrap.addEventListener('touchstart', stop, { passive: true });
      wrap.addEventListener('mouseenter', stop);
      wrap.addEventListener('mouseleave', start);
      wrap.addEventListener('touchend', function(){ setTimeout(restart, 600); }, { passive: true });
      wrap.addEventListener('pointerup', function(){ setTimeout(restart, 600); });
      document.addEventListener('visibilitychange', function(){ if(document.hidden) stop(); else start(); });

      start();
    }

    function initAll(){
      var nodes = document.querySelectorAll('.halo-trust');
      for(var i = 0; i < nodes.length; i++) init(nodes[i]);
    }
    if(document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('shopify:block:select', initAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["judgeme-stars"] && !Shopify.designMode) return;
  try {
    (function(){
  var STAR_PATH = 'M12 2.2l2.9 5.9 6.5.95-4.7 4.58 1.11 6.47L12 17.06 6.19 20.1l1.11-6.47L2.6 9.05l6.5-.95z';

  function starHtml(pct){
    var rightInset = 100 - pct; // clip from the right
    return '<span class="jm-star">'
      + '<svg class="jm-star__bg" viewBox="0 0 24 24"><path d="'+STAR_PATH+'"/></svg>'
      + '<svg class="jm-star__fg" viewBox="0 0 24 24" style="clip-path:inset(0 '+rightInset+'% 0 0)"><path d="'+STAR_PATH+'"/></svg>'
      + '</span>';
  }

  function init(root){
    if(root.dataset.ready) return;
    root.dataset.ready = '1';
    var debugEl = root.parentNode.querySelector('[data-jm-debug]');
    var log = [];
    function report(){ if(debugEl){ debugEl.textContent = log.join('\n'); } }

    function findRating(){
      var ratingEl = document.querySelector('.jdgm-rating-text');
      var countEl  = document.querySelector('.jdgm-reviews-count');
      var avg = null, count = null;
      if(ratingEl){
        var m = ratingEl.textContent.trim().match(/[\d.]+/);
        if(m){ avg = parseFloat(m[0]); }
        log.push('rating: "'+ratingEl.textContent.trim()+'" -> '+avg);
      } else { log.push('.jdgm-rating-text not found'); }
      if(countEl){
        var c = countEl.textContent.replace(/[^\d]/g,'');
        if(c){ count = parseInt(c,10); }
      } else if(ratingEl){
        var mc = ratingEl.textContent.match(/\((\d+)\)/);
        if(mc){ count = parseInt(mc[1],10); }
      }
      if(avg !== null && count !== null){ return { avg: avg, count: count }; }
      return null;
    }

    function render(data){
      var rowEl = root.querySelector('.jm-stars__row');
      var html = '';
      for(var i=1;i<=5;i++){
        var fill = Math.max(0, Math.min(1, data.avg - (i-1))) * 100;
        html += starHtml(fill);
      }
      rowEl.innerHTML = html;
      var txtEl = root.querySelector('.jm-stars__text');
      if(txtEl){ txtEl.textContent = (Math.round(data.avg*10)/10) + ' | ' + data.count + ' reviews'; }
      root.setAttribute('aria-label', (Math.round(data.avg*10)/10)+' out of 5, '+data.count+' reviews');
      root.removeAttribute('hidden');
    }

    var tries = 0;
    var iv = setInterval(function(){
      tries++;
      var data = findRating();
      if(data && data.count > 0){ render(data); report(); clearInterval(iv); return; }
      if(tries > 50){ report(); clearInterval(iv); }
    }, 100);
  }

  function initAll(){ document.querySelectorAll('[data-jm-stars]').forEach(init); }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', initAll); }
  else { initAll(); }
  document.addEventListener('shopify:section:load', initAll);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["stock-indicator"] && !Shopify.designMode) return;
  try {
    (function(){
  function init(root){
    if(root.dataset.ready) return;
    root.dataset.ready = '1';

    var dataEl = root.querySelector('[data-stock-data]');
    var out = root.querySelector('[data-stock-output]');
    var threshold = parseInt(root.getAttribute('data-threshold'), 10) || 15;
    var lowLabel = root.getAttribute('data-low-label') || 'Low stock';
    var inLabel = root.getAttribute('data-instock-label') || 'In stock';
    var data = {};
    try { data = JSON.parse(dataEl.textContent); } catch(e){ return; }

    var lastId = null;

    function render(variantId){
      variantId = String(variantId || '');
      if(!variantId || variantId === lastId) return;
      lastId = variantId;
      var v = data[variantId];
      if(!v || !v.tracked){ out.innerHTML = ''; return; }
      var qty = v.qty;
      if(qty > 0 && qty < threshold){
        var pct = Math.max(4, Math.round(qty * 100 / threshold));
        out.innerHTML =
          '<div class="stock-indicator stock-indicator--low">' +
            '<p class="stock-indicator__text"><strong>' + lowLabel + '</strong> <span>~ Only ' + qty + ' left</span></p>' +
            '<div class="stock-indicator__bar-track"><div class="stock-indicator__bar-fill" style="width:' + pct + '%"></div></div>' +
          '</div>';
      } else if(qty >= threshold){
        out.innerHTML =
          '<div class="stock-indicator stock-indicator--in-stock">' +
            '<span class="stock-indicator__dot"></span><span>' + inLabel + '</span>' +
          '</div>';
      } else {
        out.innerHTML = '';
      }
    }

    // Find the product form this block belongs to (nearest, else on the page)
    function form(){
      var scope = root.closest('.shopify-section, product-information, [id^="MainProduct"]') || document;
      return scope.querySelector('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
    }

    // Read the currently selected variant id from whatever Horizon exposes
    function currentId(){
      var f = form();
      if(f){
        var idInput = f.querySelector('input[name="id"], select[name="id"]');
        if(idInput && idInput.value) return idInput.value;
      }
      // URL ?variant= as a fallback (Horizon updates this on selection)
      var m = window.location.search.match(/[?&]variant=(\d+)/);
      if(m) return m[1];
      return root.getAttribute('data-current');
    }

    // 1) initial
    render(currentId());

    // 2) explicit events some themes emit
    document.addEventListener('variant:change', function(e){
      var variant = e.detail && (e.detail.variant || e.detail);
      if(variant && variant.id) render(variant.id);
    });
    document.addEventListener('change', function(e){
      if(e.target && e.target.name === 'id'){ render(e.target.value); }
    });

    // 3) watch the hidden id input for value changes (Horizon updates it)
    var f = form();
    if(f){
      var idInput = f.querySelector('input[name="id"], select[name="id"]');
      if(idInput){
        var mo = new MutationObserver(function(){ render(idInput.value); });
        mo.observe(idInput, { attributes:true, attributeFilter:['value'] });
      }
    }

    // 4) safety-net poll (covers URL-based swatch changes with no input event)
    setInterval(function(){ render(currentId()); }, 400);
  }

  function initAll(){ document.querySelectorAll('[data-stock-indicator]').forEach(init); }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', initAll); }
  else { initAll(); }
  document.addEventListener('shopify:section:load', initAll);
})();
  } catch(e) { console.error(e); }
})();

})();
